export const calculateCoupon = (
  price: number,
  percentage: number,
  minRequirement: number,
  maxAmount: number
): number => {
  if (price < minRequirement) {
    return 0;
  }

  // Andaikata gaada persenan, dia bakal balikin harganya lagi
  const discounted = percentage ? (price * percentage) / 100 : price;

  if (discounted < 0) {
    return 0;
  }

  if (discounted > maxAmount) {
    return Math.ceil(maxAmount);
  }

  return Math.ceil(discounted);
};
